<template>
  <f7-page @page:afterin="pageMounted">
    <f7-block class="content">
      <div>帳號登入中...</div>
      <f7-progressbar infinite style="width: 80%;" />
    </f7-block>
  </f7-page>
</template>

<script>
import { mapState } from 'vuex'

export default {
  dependencies: ['userSignInStatusType'],
  computed: {
    ...mapState('userModule', ['signInStatus'])
  },
  data () {
    return {
      hasPageMounted: false
    }
  },
  watch: {
    signInStatus (status) {
      if (this.hasPageMounted) {
        this.checkRedirect()
      }
    }
  },
  methods: {
    getQueryString (name) {
      const url = window.location.href
      name = name.replace(/[[\]]/g, '\\$&')
      const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
      const results = regex.exec(url)
      if (!results) {
        return null
      }
      if (!results[2]) {
        return ''
      }
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    },
    pageMounted () {
      this.checkRedirect()
      this.hasPageMounted = true
    },
    checkRedirect () {
      const url = this.getQueryString('r')
      if (this.signInStatus === this.userSignInStatusType.processing) {
        // return
      } else if (this.signInStatus === this.userSignInStatusType.signedIn) {
        if (url) {
          this.$f7router.navigate(url, { reloadCurrent: true })
        } else {
          this.$f7router.navigate('/', { reloadCurrent: true })
        }
      } else {
        this.$f7router.navigate(`/auth${url ? `?r=${url}` : ''}`, { reloadCurrent: true })
      }
    }
  },
  mounted () {
    if (this.signInStatus === this.userSignInStatusType.signedIn) {
      const url = this.getQueryString('r')
      this.$f7router.navigate(url, { reloadCurrent: true })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.content * {
  font-size: 18px;
  margin: 10px;
}
</style>
